<template>
  <a-card
    id="non-critical-steps-container"
    :body-style="{ height: '73vh', overflowY: 'auto' }"
  >
    <template #title>
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="my-auto">
          <strong>{{ taskName }}</strong>
        </h6>
        <a-space>
          <span>Task has low confidence steps</span>
          <a-switch
            id="non-critical-steps-toggle"
            :checked="hasNonCritical"
            @change="handleToggle"
          />
        </a-space>
      </div>
    </template>

    <a-alert
      v-if="!hasNonCritical"
      type="info"
      show-icon
      message="Enable the toggle to mark substeps as low confidence. A cycle whose only missed steps are low confidence still counts as a good cycle."
      class="mb-2"
    />

    <a-list
      v-else
      :id="taskName + '-non-critical-steps-list'"
      :grid="{ gutter: 16, column: 1 }"
      size="small"
      :data-source="taskProcesses"
      :loading="isUpdatingNonCriticalSteps"
    >
      <template #renderItem="{ item: process }">
        <a-card
          size="small"
          class="mb-2"
          :body-style="{
            overflowY: 'auto',
            overflowX: 'hidden',
            height: '55vh',
            padding: '0.5em !important',
          }"
        >
          <template #title>
            <h6 class="m-0">
              <span class="text-secondary">Process: </span>
              <strong>{{ process.name }}</strong>
            </h6>
          </template>

          <a-list
            :id="process.name + '-non-critical-steps'"
            :grid="{ gutter: 16, column: 1 }"
            size="small"
            :data-source="process.steps"
          >
            <template #renderItem="{ item: step }">
              <a-list-item :id="step + '-non-critical-single'">
                <a-card
                  size="small"
                  class="w-100"
                  :body-style="{ padding: '0' }"
                >
                  <template #title>
                    <p :id="'non-critical-' + step + '-name'" class="m-0">
                      <span class="text-secondary">Step: </span>
                      <strong>{{ step.name }}</strong>
                    </p>
                  </template>
                  <a-list size="small" :data-source="step.substeps">
                    <template #renderItem="{ item: substep }">
                      <a-list-item
                        :id="substep + '-non-critical-li'"
                        class="d-flex p-1"
                        :style="{ background: '#F1F1F1' }"
                      >
                        <span :id="substep + '-non-critical-name'" class="w-75 px-2">
                          <span
                            class="text-secondary mr-2 non-critical-step-index"
                          >#{{ stepsToIndexMapping[substep]?.index + 1 }}</span>
                          {{ substep }}
                        </span>
                        <a-checkbox
                          :id="substep + '-non-critical-checkbox'"
                          :checked="checkedSteps.includes(substep)"
                          class="ml-auto"
                          @change="handleChange(substep)"
                        />
                      </a-list-item>
                    </template>
                  </a-list>
                </a-card>
              </a-list-item>
            </template>
          </a-list>
        </a-card>
      </template>
    </a-list>

    <div class="d-flex pt-2">
      <a-space class="ml-auto">
        <a-button
          id="non-critical-steps-cancel-btn"
          :disabled="isUpdatingNonCriticalSteps"
          @click="updateNonCriticalStepsModalState(false)"
        >
          Cancel
        </a-button>
        <a-button
          id="non-critical-steps-save-btn"
          type="primary"
          :disabled="isUpdatingNonCriticalSteps"
          @click="handleSave"
        >
          Save
        </a-button>
      </a-space>
    </div>
  </a-card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      hasNonCritical: false,
      checkedSteps: [],
      stepsToIndexMapping: {},
    };
  },
  computed: {
    ...mapGetters([
      'taskProcesses',
      'hasNonCriticalSteps',
      'nonCriticalSteps',
      'taskName',
      'isUpdatingNonCriticalSteps',
    ]),
  },
  mounted() {
    this.initializeState();
    this.hasNonCritical = this.hasNonCriticalSteps;
    // Pre-check saved names, dropping any that are no longer present as substeps.
    this.checkedSteps = this.nonCriticalSteps.filter(
      (name) => name in this.stepsToIndexMapping
    );
  },
  methods: {
    ...mapActions(['updateNonCriticalStepsModalState', 'updateNonCriticalSteps']),

    initializeState() {
      this.stepsToIndexMapping = this.taskProcesses
        .reduce((res, process) => [...res, ...process.steps], [])
        .reduce((res, step) => [...res, ...step.substeps], [])
        .reduce((res, substep, index) => {
          res[substep] = { index };
          return res;
        }, {});
    },

    handleToggle(checked) {
      this.hasNonCritical = checked;
    },

    handleChange(substep) {
      if (!this.checkedSteps.includes(substep)) {
        this.checkedSteps.push(substep);
      } else {
        const index = this.checkedSteps.indexOf(substep);
        this.checkedSteps.splice(index, 1);
      }
    },

    handleSave() {
      this.updateNonCriticalSteps({
        hasNonCriticalSteps: this.hasNonCritical,
        nonCriticalSteps: this.checkedSteps,
      });
    },
  },
};
</script>
<style scoped>
.non-critical-step-index {
  display: inline-block;
  min-width: 2.25em;
  text-align: right;
}
</style>
